import { render, staticRenderFns } from "./analysisFun3.vue?vue&type=template&id=5b23c0b5&scoped=true&"
import script from "./analysisFun3.vue?vue&type=script&lang=js&"
export * from "./analysisFun3.vue?vue&type=script&lang=js&"
import style0 from "./analysisFun3.vue?vue&type=style&index=0&id=5b23c0b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b23c0b5",
  null
  
)

export default component.exports